export default {"src":"/_next/static/media/faq-icon11.e9e547be.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};